/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProductTypeEnum = "Business_NonStandard" | "Business_Standard" | "Enterprise_NonStandard" | "Enterprise_Standard" | "Pro_NonStandard" | "Pro_Standard" | "%future added value";
export type SuggestedTeamReasonType = "NumMeetingsWithOverlap" | "NumOneOnOnesWithOverlap" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type TeamJoinCreate_org = {
    readonly id: string;
    readonly primaryOrgCalendar: string;
    readonly orgPersonForUserErrorable: {
        readonly personId?: string | undefined;
    };
    readonly primaryTeam: ({
        readonly __typename: "Team";
        readonly teamId: string;
        readonly teamName: string;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly billingGroups: {
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly syncSources: ReadonlyArray<{
                readonly type: UrnType | null;
                readonly value: string | null;
            }>;
            readonly subscription: {
                readonly __typename: "SubscriptionDetails";
                readonly subscription: {
                    readonly id: string;
                    readonly productType: ProductTypeEnum | null;
                };
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
        }> | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
    };
    readonly userTeams: {
        readonly __typename: "TeamList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly teamId: string;
            readonly teamName: string;
            readonly createdBy: {
                readonly value: string | null;
            };
            readonly teamCalendarId: string | null;
            readonly settings: {
                readonly __typename: "TeamSettings";
                readonly manageTeamCalendar: boolean;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly userSettings: {
                readonly __typename: "TeamUserSettings";
                readonly useTeamCalendar: boolean;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly teamMembers: ReadonlyArray<{
                readonly person: {
                    readonly __typename: string;
                    readonly id: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                        readonly externalImageUrl: string | null;
                    } | null;
                };
            }>;
            readonly invitedMembers: ReadonlyArray<{
                readonly person: {
                    readonly __typename: string;
                    readonly id: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                        readonly externalImageUrl: string | null;
                    } | null;
                };
            }>;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly suggestedTeams: {
        readonly __typename: "SuggestedTeamList";
        readonly list: ReadonlyArray<{
            readonly team: {
                readonly id: string;
                readonly teamId: string;
                readonly teamName: string;
                readonly createdBy: {
                    readonly value: string | null;
                };
                readonly teamMembers: ReadonlyArray<{
                    readonly person: {
                        readonly __typename: string;
                        readonly id: string;
                        readonly primaryCalendarId: string;
                        readonly isYou: boolean;
                        readonly userId: string | null;
                        readonly personId: string;
                        readonly profile: {
                            readonly givenName: string | null;
                            readonly familyName: string | null;
                            readonly externalImageUrl: string | null;
                        } | null;
                    };
                }>;
                readonly invitedMembers: ReadonlyArray<{
                    readonly person: {
                        readonly __typename: string;
                        readonly id: string;
                        readonly primaryCalendarId: string;
                        readonly isYou: boolean;
                        readonly userId: string | null;
                        readonly profile: {
                            readonly givenName: string | null;
                            readonly familyName: string | null;
                            readonly externalImageUrl: string | null;
                        } | null;
                    };
                }>;
            };
            readonly reasons: ReadonlyArray<{
                readonly type: SuggestedTeamReasonType;
                readonly value: number;
            }>;
            readonly score: number;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsSearch_org" | "TeamSearchInputRenderer_org">;
    readonly " $refType": "TeamJoinCreate_org";
};
export type TeamJoinCreate_org$data = TeamJoinCreate_org;
export type TeamJoinCreate_org$key = {
    readonly " $data"?: TeamJoinCreate_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        (v7 /*: any*/)
    ], v9 = {
        "kind": "InlineFragment",
        "selections": [
            (v6 /*: any*/),
            (v5 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            (v7 /*: any*/)
        ],
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v15 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v2 /*: any*/),
                (v0 /*: any*/),
                (v11 /*: any*/),
                (v12 /*: any*/),
                (v13 /*: any*/),
                (v1 /*: any*/),
                (v14 /*: any*/)
            ],
            "storageKey": null
        } as any
    ], v16 = {
        "alias": null,
        "args": null,
        "concreteType": "TeamMember",
        "kind": "LinkedField",
        "name": "teamMembers",
        "plural": true,
        "selections": (v15 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "TeamJoinCreate_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgPersonForUserErrorable",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v1 /*: any*/)
                        ],
                        "type": "OrgPerson",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v3 /*: any*/),
                            (v4 /*: any*/)
                        ],
                        "type": "Team",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v5 /*: any*/),
                            (v6 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingGroup",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Urn",
                                        "kind": "LinkedField",
                                        "name": "syncSources",
                                        "plural": true,
                                        "selections": (v8 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "subscription",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "PaymentSubscription",
                                                        "kind": "LinkedField",
                                                        "name": "subscription",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "productType",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "SubscriptionDetails",
                                                "abstractKey": null
                                            },
                                            (v9 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "BillingGroupList",
                        "abstractKey": null
                    },
                    (v9 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    (v10 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamCalendarId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "settings",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "manageTeamCalendar",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "TeamSettings",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "userSettings",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "useTeamCalendar",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "TeamUserSettings",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    (v16 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "invitedMembers",
                                        "plural": true,
                                        "selections": (v15 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TeamList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "suggestedTeams",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedTeam",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Team",
                                        "kind": "LinkedField",
                                        "name": "team",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v3 /*: any*/),
                                            (v4 /*: any*/),
                                            (v10 /*: any*/),
                                            (v16 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TeamMember",
                                                "kind": "LinkedField",
                                                "name": "invitedMembers",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "OrgPerson",
                                                        "kind": "LinkedField",
                                                        "name": "person",
                                                        "plural": false,
                                                        "selections": [
                                                            (v2 /*: any*/),
                                                            (v0 /*: any*/),
                                                            (v11 /*: any*/),
                                                            (v12 /*: any*/),
                                                            (v13 /*: any*/),
                                                            (v14 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SuggestedTeamReason",
                                        "kind": "LinkedField",
                                        "name": "reasons",
                                        "plural": true,
                                        "selections": (v8 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "score",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SuggestedTeamList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSettingsSearch_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSearchInputRenderer_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '5a231cf9aa8f737f85ec4965e79c3430';
export default node;
